import { render } from "./Title3.vue?vue&type=template&id=59b14bb6"
import script from "./Title3.vue?vue&type=script&lang=ts"
export * from "./Title3.vue?vue&type=script&lang=ts"

import "./Title3.vue?vue&type=style&index=0&id=59b14bb6&lang=scss"
script.render = render

export default script